import { SET_SEARCH_RESULTS } from '../actions/types';
import { SET_PREV_PAGE } from '../actions/types';

const initialState = {
    searchResults: null,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_SEARCH_RESULTS:
            return {
                ...state,
                searchResults: action.payload
            }
        case SET_PREV_PAGE:
            return {
                ...state,
                prevUrl : action.payload
            }
        default:
            return state;
    }
}